import { SxProps } from '@mui/material';

export const style: SxProps = {
  display: 'flex',
  flexWrap: 'wrap',
};
